import React from 'react';
import { Avatar, Box } from '@material-ui/core';
import { shortenName } from '../../../utils/strings';

interface IProps {
  id?: number;
  image?: string;
  name: string;
  email?: string;
  className?: string;
  background?: string;
  onClick?: (e: any) => void;
}
export default function CustomAvatar(props: IProps) {
  return (
    <Box
      className={props.className ? props.className : ''}
      onClick={(e) => props?.onClick?.(e) ?? (() => {})}
    >
      {props.image ? (
        <Avatar
          src={props.image}
          className={props.className ? props.className : ''}
        />
      ) : (
        <Avatar
          style={{ background: props?.background || '#816BFF' }}
          className={props.className ? props.className : ''}
        >
          {shortenName(props.name).toUpperCase()}
        </Avatar>
      )}
    </Box>
  );
}
